import {IntermediatePart} from "../../intermediatePart";
import isEqual from "lodash/isEqual";

export default class Attachment extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "attachment";
    this.partName = "Attachment";
    this.hasAdditionalParts = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Attachment());
  }

  checkIfFeaturePartIsMatching() {
    this.activeFeatureParts = this.setActiveFeatureParts();
  }

  setActiveFeatureParts() {
    const layout = this.getParent().layout;
    const activeFeatures = layout.getActiveFeatures(true, true);
    // console.log("activeFeatures", activeFeatures);
    const matchingFeatures = this.features.filter(feature => {
      if (!feature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())) {
        return false
      }
      return feature.metaData["MatchingFeature"] && activeFeatures.some(cartItem => {
        if (cartItem.partId === this.partId) { // remove attachment active feature
          return false
        }
        return !cartItem.featureGroup.disabled && cartItem.cartFeature.metaData["MatchingFeature"]
          && isEqual(feature.metaData["MatchingFeature"], cartItem.cartFeature.metaData["MatchingFeature"])
          && isEqual(feature.metaData["Side"], cartItem.cartFeature.metaData["Side"])
      })
    })
    // console.log("matchingFeatures", matchingFeatures);
    return matchingFeatures;
  }

  setZIndex(zIndexes) {

    const getZIndex = (feature, partId = null) => {
      return feature.metaData["ZSorting"] ? feature.metaData["ZSorting"] * 1000 : zIndexes[partId || this.partId];
    }

    if (this.hasAdditionalParts && this.activeFeatureParts && this.activeFeatureParts.length) {
      this.activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.layer.zIndex = getZIndex(activeFeaturePart, this.additionalPartPartId) - 1;
      });
    }
  }

}
